import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { TelegramAuthProvider } from './providers';
import App from './App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <TelegramAuthProvider>
      <App />
    </TelegramAuthProvider>
  </StrictMode>
);
